import { styled } from "@linaria/react"

export const GradientBlob = styled.div`
  position: fixed;
  bottom: -216px;
  left: 50%;

  transform: translateX(-50%);

  width: var(--limited-centered-width);
  height: 324px;

  border-radius: var(--border-radius-16);
  background: conic-gradient(from 81deg at 50% 50%, rgb(54 252 255 / 30%) 13.8462deg, rgb(159 159 255 / 30%) 199.0385deg, rgb(217 151 255 / 30%) 259.6154deg, rgb(178 156 255 / 30%) 338.8353deg);
  filter: blur(135px);

  z-index: -1;
`
